import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { UPDATE_NAV_ITEM } from '../../../../../store/js/modules/statspro/stats-leaders/actions';
import { statsLeadersNavSelector } from '../../../../../store/js/modules/statspro/stats-leaders/selectors';

export const useStatsLeadersNavSync = ( { competitions, seasons, rounds } ) => {
    const dispatch = useDispatch();
    const nav = useSelector( statsLeadersNavSelector );

    /**
     * Ensure stats leaders nav data is correct.
     */
    useEffect( () => {
        if ( competitions && !nav.competition.id ) {
            // @ts-expect-error
            const { PREMIERSHIP } = PULSE.app.common.CONSTANTS.PROVIDER_IDS;
            const aflPremiershipCompetition = competitions.find(
                comp => comp.providerId === PREMIERSHIP
            );

            if ( aflPremiershipCompetition ) {
                dispatch(
                    UPDATE_NAV_ITEM.request( {
                        navItem: 'competition',
                        value: { id: aflPremiershipCompetition.id }
                    } )
                );
            }
        }

        if ( seasons && !nav.season.id ) {
            dispatch(
                UPDATE_NAV_ITEM.request( {
                    navItem: 'season',
                    value: { id: seasons[ 0 ].id }
                } )
            );
        }

        if ( rounds && nav.round.id === null ) {
            dispatch(
                UPDATE_NAV_ITEM.request( {
                    navItem: 'round',
                    value: {
                        id: -1,
                        number: 0
                    }
                } )
            );
        }
    }, [ competitions, seasons, rounds ] );

    useEffect( () => {
        if ( !rounds || !seasons || nav.round.id === null || nav.round.id === -1 ) { return; }

        // If rounds is empty, reset to Entire season
        if ( !rounds?.length ) {
            dispatch(
                UPDATE_NAV_ITEM.request( {
                    navItem: 'round',
                    value: {
                        id: -1,
                        number: 0
                    }
                } )
            );
        } else if ( !rounds.find( r => r.id === nav.round.id ) ) {
            const targetRound = rounds.find(
                r => r.roundNumber === nav.round.number
            ) ?? rounds[ 0 ];

            dispatch(
                UPDATE_NAV_ITEM.request( {
                    navItem: 'round',
                    value: {
                        id: targetRound.id,
                        number: targetRound.roundNumber
                    }
                } )
            );
        }
    }, [ nav.round, rounds, seasons ] );
};